const justImportedCampaignIDs = new Set();

export const markCampaignAsJustImported = (campaignID) => {
  if (campaignID) {
    justImportedCampaignIDs.add(campaignID);
  }
};

export const consumeJustImportedCampaign = (campaignID) => {
  if (justImportedCampaignIDs.has(campaignID)) {
    justImportedCampaignIDs.delete(campaignID);
    return true;
  }
  return false;
};
